import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DollarSvgComponent, EuroSvgComponent, PoundSvgComponent } from '@uc/shared/svg';

@Component({
	selector: 'uc-no-fees-and-funding',
	templateUrl: './no-fees-and-funding.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [EuroSvgComponent, PoundSvgComponent, DollarSvgComponent],
})
export class NoFeesAndFundingComponent {
	courseName = input.required<string>();
}
